export enum Cin7OmniBomImportStrategy {
  IMPORT_PARENT_AND_CHILDREN = "import_parent_and_children",
  IMPORT_PARENT = "import_parent",
}
